<template>
    <div>
      <pretty-json :json="recursivelyParseSchema(model)"></pretty-json>
    </div>
</template>
<script>
import PrettyJson from './PrettyJsonComponent.vue';

export default {
  data() {
    return {
      step: 0
    }
  },
  mounted() {
    
  },
  props: { model: Object, schemas: Object },
  components: {
    PrettyJson
  },
  methods: {
    recursivelyParseSchema(model) {
      if (!model) return;
      // this model can have two complex types; object or array
      // alternatively it is a simple object and does not need processing
      if (model.type == 'object') {
        // if it's an object, we'll need to recursively parse through it until it's just simple types
        const ro = {};
        Object.keys(model.properties).forEach(key => {
          // let's get the properties
          const value = model.properties[key];
          if (value.type && value.type != 'array') { // if there's a type and the type is not array
            // assign the type since it's primitive
            ro[key] = value.type;
          } else if (value.type && value.type == 'array') { // otherwise, there's a type and it's an array
            // simply process it
            ro[key] = this.recursivelyParseSchema(value); 
          } else { // no type, means complex object
            // retrieve the schema for it
            let complexObject = null;
            if (value.oneOf && value.oneOf.length) {
              complexObject = value.oneOf[0].$ref;
            } else {
              complexObject = value.$ref;
            }
            
            const subSchema = this.schemas[this.getClassNameFromRef(complexObject)]
            // then recursively parse the schema
            ro[key] = this.recursivelyParseSchema(subSchema);
          }
          // if there's a format, add it (only on primitives);
          if (value.format) ro[key] += ` (${value.format})`;
        });
        return ro;
      } 
      if (model.type == 'array') {
        const ref = model.items.$ref;
        if (!ref) return [model.items.type];
        const className = this.getClassNameFromRef(ref);
        const recursiveModel = this.recursivelyParseSchema(this.schemas[className]);
        return [recursiveModel];
      }
      return model;
    },
    getClassNameFromRef(ref) {
      const splitArray = ref.split('/');
      return splitArray[splitArray.length - 1];
    }
  }
}
</script>
